module.exports = { id: "e-bike", url: "/build/app/img/symbols.svg#e-bike", viewBox: "", toString: function() { return this.url; } };